import React from 'react'
import { useContext } from 'react'
import Swal from '../../shared/SweetAlert';
import { AppContext } from "../../App";
import { useNavigate } from "react-router";
import { useState } from 'react';
import { Modal } from "@material-ui/core";
import "./css/PromoCondi.css"
import Button from '../controls/Button';
import CheckBox from '../controls/CheckBox';

export default function PromoCondi(props) {
    const appContext = useContext(AppContext)
    const [loadingContinue, setLoadingContinue] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [open, setOpen] = useState(true);
    const navigate = useNavigate()

    const AñadirProducto = async (codigo) => {
        setLoadingContinue(true);
        await fetch(
            new Request(
                appContext.appState.baseUrl +
                "carrito/producto/" + localStorage.getItem("id-carrito") + "?codigoInventario=" + codigo + "&cantidad=1&tipoPago=efectivo",
                {
                    method: "POST",
                    headers: {
                        "Content-type": "application/json"
                    }
                }
            )
        )
            .then((response) => {
                if (response.ok === true) {
                    return response.json();
                }
                throw response.json();
            })
            .then((data) => {
            })
            .catch((error) => {
                error.then(function (e) {
                    if (e.state.Code === 1004 || e.state.Code === 1077) {
                        navigate("/limpiar_carrito");
                    }
                    else if (e.state.Code === 1004) {
                        navigate("/entrega")
                    } else {
                        throw e.state.Message
                    }
                }).catch((e) => { 
                    handleClose()
                    Swal.fire({
                        title: 'Error',
                        text: e,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: 'Orange',
                    }).then(() => {
                        navigate('/carrito')
                    })
                 })

            }).finally(() => {
                setLoadingContinue(false)
            })
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleProductSelection = (productCode) => {
        if (selectedProducts.includes(productCode)) {
            setSelectedProducts(selectedProducts.filter(code => code !== productCode));
        } else {
            setSelectedProducts([...selectedProducts, productCode]);
        }
    };

    const handleContinue = async () => {
        try {
            for (let product of selectedProducts) {
                await AñadirProducto(product)
            }
            handleClose()
            Swal.fire({
                title: 'Producto añadido',
                text: 'Producto en promoción ha sido añadido exitosamente',
                icon: 'success',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: 'Orange',
            }).then(() => {
                handleOpen()
                if (props.setProductos !== undefined) props.setProductos([])
                navigate("/carrito")
            })
        } catch (e) {
            handleClose()
            Swal.fire({
                title: 'Lo sentimos',
                text: e,
                icon: 'error',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: 'Orange',
            }).then(() => {
                handleOpen()
            })
        }

    }

    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
                BackdropProps={{
                    style: { pointerEvents: "none" }
                }}
            >
                <div className='promocondi-select-container'>
                    <div className="modal-content">
                        <h2>Promociones</h2>
                        <p>El producto que acabas de agregar tiene en promoción estos productos, selecciona los productos que desees agregar y lugo presiona el botón de continuar:</p>
                        <br />
                        <div>
                            {props.productos.length > 0 ? props.productos.map(producto => {
                                return (
                                    <div key={producto.Codigo} className='promocondi-item-row'>
                                        <div>
                                            <img src={producto.Imagen} alt='producto'/>
                                        </div>
                                        <p>{producto.Descripcion}</p>
                                        <div style={{ minWidth: "90px" }}>
                                            <CheckBox
                                                Label="Añadir"
                                                onChange={() => handleProductSelection(producto.Codigo)}
                                            ></CheckBox>
                                        </div>
                                    </div>
                                )
                            }) : <></>}
                        </div>
                        <div style={{ position: "relative", marginTop: "30px" }}>
                            <Button
                                className='btn-intelaf-orange'
                                ButtonLoading={loadingContinue}
                                Texto="Continuar"
                                height={40}
                                textSize={13}
                                style={{ width: "100%", height: "40px" }}
                                onClick={handleContinue}
                            ></Button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
